import { combineTokens } from '@utils/css';

const tokens = combineTokens("--text-export--content", {
  columnCount: 1
});
const section = "_rss1wt6669";
const wrapper = "_rsww4d3gz";
const heading = "_rshh896ub";
const content = "_rsc1i0zgwb";
const caption = "_rsc1oezkyd";

export { caption, content, heading, section, tokens, wrapper };
import "./page.content.style.linaria.module.css";
//# sourceMappingURL=page.content.style.js.map
